import React, { useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import MuiButton from "Components/MuiButton/MuiButton";
import { read } from "Helpers/LocalStorage";
import UserProfileService from "Services/http/endpoints/userProfile/UserProfileService";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import VerifyModal from "./VerifyModal";
import { convertToEnglishNumber } from "../../../../Helpers/convertToEnglishNumber";
import { useTranslation } from "react-i18next";

export default function ProfilePhone({ data }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    phone: {
      value: "",
      validation: {
        required: true,
        isNumeric: true,
        isPhone: true,
      },
    },
  });
  const handleDialog = (isChange) => {
    setOpenDialog(!openDialog);
    if (openDialog && !isChange) {
      if (data) {
        const phoneWithoutCode = data.PhoneNumber.replace("+98", "0");
        setControls({ phone: { value: phoneWithoutCode } });
      }
      setFormValid({});
    } else if (openDialog && isChange) {
      setFormValid({});
    }
  };
  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const onSubmit = async () => {
    const { phone } = controls;
    const enPhone = convertToEnglishNumber(phone.value);
    const phoneWithCode = enPhone.replace("0", "+98");
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const dataPost = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Type: 2,
          Account: phoneWithCode,
        };
        const response = await UserProfileService.postProfileContact(dataPost);
        let err = StatusHandler(response);
        if (!err.isFail) {
          setOpenDialog(true);
        } else {
          if (data) {
            const phoneWithoutCode = data.PhoneNumber.replace("+98", "0");
            setControls({ phone: { value: phoneWithoutCode } });
          }
          setFormValid({});
        }
        setLoading(false);
      } catch (e) {
        if (data) {
          const phoneWithoutCode = data.PhoneNumber.replace("+98", "0");
          setControls({ phone: { value: phoneWithoutCode } });
        }
        setFormValid({});
        setLoading(false);
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "warning",
      });
    }
  };

  const resendCode = async () => {
    try {
      setLoading(true);
      const { phone } = controls;
      const enPhone = convertToEnglishNumber(phone.value);
      const phoneWithCode = enPhone.replace("0", "+98");

      const dataPost = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Type: 2,
        Account: phoneWithCode,
      };
      const response = await UserProfileService.postProfileContact(dataPost);
      let err = StatusHandler(response);
      if (!err.isFail) {
      } else {
        if (data) {
          const phoneWithoutCode = data.PhoneNumber.replace("+98", "0");
          setControls({ phone: { value: phoneWithoutCode } });
        }
        setFormValid({});
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      const phoneWithoutCode = data.PhoneNumber.replace("+98", "0");
      setControls({ phone: { value: phoneWithoutCode } });
    }
  }, [data]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2}>
        <Grid item sm={4} xs={12}>
          <Input
            className="phone"
            setValue={setValue.bind(this)}
            name="phone"
            validation={controls.phone.validation}
            placeholder={t("input_phone")}
            label={<Translator id="input_phone" />}
            type="text"
            fullWidth
            helperText={"mobileExample"}
            value={controls.phone.value}
          />
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          className="d-flex flex-row justify-content-start align-items-center"
        >
          <MuiButton
            loading={loading}
            color="primary"
            title={<Translator id="zakhire" />}
            onClick={onSubmit}
            disabled={R.isEmpty(formValid)}
            fullwidthOnSm
          />
        </Grid>
      </Grid>
      <VerifyModal
        type={2}
        open={openDialog}
        handleDialog={handleDialog}
        account={controls.phone.value}
        resendCode={resendCode}
      />
    </>
  );
}
